import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@piconetworks/ui'

class TdComponent extends PureComponent {

    render() {
        const { children, style, className, handleEdit } = this.props

        return (
            <Box.Flexbox.Child style={style} className={className} onClick={handleEdit}>
                {children}
            </Box.Flexbox.Child>
        )
    }
}

TdComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    handleEdit: PropTypes.func,
    style: PropTypes.object
}

export default TdComponent
